import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CategoryResolutionObservation,
  VatResolutionObservation,
} from '../common/ResolutionObservation';
import { ApiServiceBase } from './ApiServiceBase';

// Backend #623: BFF pass-through to the resolution-observation reads (carrier-admin only) —
// the first half of the curation loop beside the vocabulary grid. Newest first; take is
// fail-closed server-side at 1..500 (default 100).
@Injectable({
  providedIn: 'root',
})
export class ResolutionObservationsService extends ApiServiceBase {
  protected readonly path = 'resolutionobservations';

  getCategoryObservations(
    correlationKeyPrefix?: string,
    take?: number
  ): Observable<CategoryResolutionObservation[]> {
    return this.http
      .get<CategoryResolutionObservation[]>(this.getUrl() + '/productcategory', {
        params: this.params(correlationKeyPrefix, take),
      });
  }

  getVatObservations(
    correlationKeyPrefix?: string,
    take?: number
  ): Observable<VatResolutionObservation[]> {
    return this.http
      .get<VatResolutionObservation[]>(this.getUrl() + '/vat', {
        params: this.params(correlationKeyPrefix, take),
      });
  }

  private params(correlationKeyPrefix?: string, take?: number): HttpParams {
    let params = new HttpParams();
    if (correlationKeyPrefix) {
      params = params.set('correlationKeyPrefix', correlationKeyPrefix);
    }
    if (take) {
      params = params.set('take', take);
    }
    return params;
  }
}
